import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CustomService } from '../shared/services/custom.service';
import { DatePipe } from '@angular/common';
import { AuthService } from '../auth.service';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx-js-style';

@Component({
  selector: 'app-search-discrepancy',
  templateUrl: './search-discrepancy.component.html',
  styleUrls: ['./search-discrepancy.component.css']
})
export class SearchDiscrepancyComponent {
  discrepancyData = [];
  excelDiscData = [];
  ispubResults = false;
  alertMsg = '';
  searchPubAta: any;
  first = 0;
  selectedFilter: any = 0;
  searchNotAllow = false;
  ifSplAlertMsg = false;
  searchNotAllowMsg = '';

  panels = [
    { title: "PUB NUMBER AND ATA SEARCH", isOpen: false, searchText: '', Flag: 1 },
    { title: "DATE RANGE SEARCH", isOpen: false, rangeDates: '', Flag: 5 },
    { title: "ORGANIZATION SEARCH", isOpen: false, searchText: '', Flag: 4 },
    { title: "DISCREPANCY ID SEARCH", isOpen: false, searchText: '', Flag: 2 },
    { title: "ADMIN ID SEARCH", isOpen: false, searchText: '', Flag: 3 }

  ];
  searchText?: any = '';
  Flag?: any = 0;
  FromDatetime: any | null;
  ToDatetime: any | null;

  constructor(private CustomService: CustomService, private _router: Router, private datePipe: DatePipe, private authService: AuthService) {

  }

  ngOnInit() {
    this.publicationTable();
    this.selectedFilter = 0;
  }

  togglePanel(panel: any) {
    this.panels.forEach((p) => {
      if (p !== panel) {
        p.isOpen = false;
        p.searchText = '';
        p.rangeDates = '';
        this.FromDatetime = '';
        this.ToDatetime = '';
      }
    });
    panel.isOpen = !panel.isOpen;
  }

  onFilterChange(filterValue: any) {
    this.selectedFilter = filterValue;

  }
  applySearch() {
    const openPanel = this.panels.find((panel) => panel.isOpen);

    if (openPanel) {
      if (openPanel.rangeDates) {
        const FromDate = openPanel.rangeDates[0];
        this.FromDatetime = this.datePipe.transform(FromDate, 'MM/dd/yyyy');
        const ToDate = openPanel.rangeDates[1];
        this.ToDatetime = this.datePipe.transform(ToDate, 'MM/dd/yyyy');
      }
      this.searchText = openPanel.searchText;
      this.Flag = openPanel.Flag;

      let splAvlNew = /[\!\^\=\|\<\>\@]/;
      this.searchNotAllow = splAvlNew.test(this.searchText);
      if (!this.searchNotAllow) {
        this.publicationTable();
      }

      else {
        this.searchNotAllowMsg = 'Special characters < > @ | ! ^ = are not allowed';
        this.ifSplAlertMsg = true;
        setTimeout(() => {
          this.ifSplAlertMsg = false;
        }, 3000);
      }
    }

  }
  applyFilters() {
    let splAvlNew = /[\!\^\=\|\<\>\@]/;
    this.searchNotAllow = splAvlNew.test(this.searchText);
    if (!this.searchNotAllow) {
      this.publicationTable();
    }
    else {
      this.searchNotAllowMsg = 'Special characters < > @ | ! ^ = are not allowed';
      this.ifSplAlertMsg = true;
      setTimeout(() => {
        this.ifSplAlertMsg = false;
      }, 3000);
    }
  }

  publicationTable() {
    this.CustomService.getAllSearchDiscrepancy(this.selectedFilter, this.searchText, this.FromDatetime, this.ToDatetime, this.Flag).subscribe(
      (res: any) => {
        if (res && res.statusCode === 200) {
          if (res && res.data && res.data && res.data.length > 0) {
            this.discrepancyData = res.data;
            this.ispubResults = true;
            this.first = 0;
          } else {
            this.ispubResults = false;
            this.discrepancyData = [];
          }
        }
      },
      error => {
        if (error) {
          this.ispubResults = false;
          this.ifSplAlertMsg = false;
          if (error.error.errors.hasOwnProperty('ToDatetime')) {
            this.alertMsg = "Please select end date before proceeding";
          } else {
            this.alertMsg = "Something went wrong, please try again";
          }
          setTimeout(() => {
            this.alertMsg = '';
          }, 3000);

        }
      });


  }

  discrepanyDetails(rowData: any, page: any) {
    this._router.navigate(['details-discrep', page, rowData.discid]);
  }

  logout() {
    this.authService.logout();
  }

  onKeyPressEvent(event: any) {
    if (event.keyCode === 33 || event.keyCode === 64 || event.keyCode === 94 ||
      event.keyCode === 61 || event.keyCode === 124 ||
      event.keyCode === 60 || event.keyCode === 62) {
      event.preventDefault();
      Swal.fire('Warning!', 'Special characters | @ ! ^ = < > are not allowed', 'warning');
    }
  }

  exportToCSV(): void{
    const table  =this.transformApiData(this.discrepancyData,this.keyToColumnMap);
  //Converting JSON to Worksheet
    const worksheet = XLSX.utils.aoa_to_sheet(table);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'DiscrepancyData');
     // Apply styles
     const colRange = 18;
     worksheet['!cols'] = Array(colRange).fill({wpx:100})// Column widths
     worksheet['!merges']=[ { s: {r: 0, c: 0}, e: {r:0, c:27}}
      
     ];
     for (let col =0; col<32 ; col++){
      const cellRef =XLSX.utils.encode_cell({ r:0, c: col});
      if (!worksheet[cellRef]){
        worksheet[cellRef] = {v:''}
      }
       worksheet[cellRef].s = {
        fill:{
          fgColor :{ rgb: "FABF8F" }
        },
        font: {
          sz: 12,
          bold: true,
        },
      };
    }
    for (let col =0; col<32 ; col++){
      const cellRef =XLSX.utils.encode_cell({ r:1, c: col});
      if (!worksheet[cellRef]){
        worksheet[cellRef] = {v:''}
      }
       worksheet[cellRef].s = {
        fill:{
          fgColor :{ rgb: "D9EAD3" }
        },
        font: {
          sz: 11,
        },
      };
    }

    // Filter data if needed here
    // e.g., const filteredData = yourFilterFunction(worksheet);
    //Write Workbook to Excel buffer
    XLSX.writeFile(workbook, 'Admin_Discrep.xlsx');

  }
  
  transformApiData(discResponse: any[],keyToColumnMap :any){
    const headers = Object.values(keyToColumnMap);
    let reportHeader: string[] =[];
    switch (this.Flag) {
      case 1:
        reportHeader = [`Discrepancy Report - Search - Publication Number and ATA is  ${this.searchText}`];
        break;
      case 5:
        reportHeader = [`Discrepancy Report - Search - DR open between ${this.FromDatetime} and ${this.ToDatetime}`];
        break;
      case 4:
        reportHeader = [`Discrepancy Report - Search - Organization is  ${this.searchText}`];
        break;
      case 2:
        reportHeader = [`Discrepancy Report - Search - Discrepancy ID is  ${this.searchText}`];
        break;
      case 3:
        reportHeader = [`Discrepancy Report - Search - Admin ID is  ${this.searchText}`]
        break;
      default:
        reportHeader = [`Discrepancy Report`]
        break;
    }
     const transformedData= discResponse.map((record : any) =>{
      return Object.keys(keyToColumnMap).map(apiKey => record[apiKey] || '')
     })
     //Insert headers at the top
     const finalData= [reportHeader, headers, ...transformedData];    
     return finalData;
  }
  keyToColumnMap ={
   "discid": "Discrepancy ID",
   "pubnumber": "Publication Number",
   "atanumber": "ATA",
   "revnumber": "Current Revision",
   "organization": "Organization",
   "publicationtype": "Publication Type",
   "pubstatus": "Publication Status",
   "license": "License",
   "userid": "User Id",
   "drstatus": "Discrepancy Status",
   "opendate": "Open Date",
   "closeddate": "Closed Date",
   "days": "Days",
   "currentdrcategory": "Current Discrepancy Category",
   "revdate": "Revision Date",
    "revyear": "Revision Year",
    "disC_DESCRIPTION": "Discrepancy Description",
    "openyear": "Open Year",
    "pageno": "Page Number",
    "parano": "Para Number",
    "tableno": "Table Number",
    "figureno": "Figure Number",
    "comments": "Comments",
    "response": "Response",
    "closedyear": "Closed Year",
    "firsT_UPD_DATE": "First Updated Year",
    "upid": "UPID",
    "exportcode": "Export Code",
    "customeR_NOTIFY_DATE":"Customer Notify Date",
    "useR_EMAIL_ADDRESS":"User Email Address"	,
    "olD_DISC_ID":"Old DISC ID",
	  "migratioN_REMARKS":"Migration Remarks"
    
  }

 

}